<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-14 15:41:49
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-19 17:03:56
-->
<template>
  <div id="app" :class="['wh100', device]">
    <transition name="fade" mode="out-in">
      <router-view class="pages"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { throttle } from '@/utils'
export default {
  computed: {
    ...mapGetters(['device', 'language'])
  },
  created () {
    // resize节流
    this.resizeChange = throttle(this.resizeChange, 200)
    this.resizeChange()
    window.addEventListener('resize', this.resizeChange, false)
  },
  methods: {
    resizeChange () {
      const clientWidth = document.documentElement.clientWidth
      const clientHeight = document.documentElement.clientHeight
      // console.log(clientWidth)
      const viewport = document.getElementsByName('viewport')[0]
      if (clientWidth > 1200) { // 默认设置当屏幕宽度 > 1000 时，为PC端
        this.$store.dispatch('app/setDevice', 'pc')
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0')
      } else { // 默认设置当屏幕宽度 <= 1000 时，为移动端
        this.$store.dispatch('app/setDevice', 'm')
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0,shrink-to-fit=no,user-scalable=no')
        // if ((this.language === 'en' && this.$route.path.indexOf('/cooperate') !== -1) || (this.language !== 'en' && this.$route.path.indexOf('/cooperate/license') !== -1)) {
        //   this.$router.replace('/').catch(() => {})
        // }
      }
      // this.$store.dispatch('app/setDevice', 'pc')
      // viewport.setAttribute('content', 'width=device-width,initial-scale=1.0')
      if (/macintosh|mac os x/i.test(navigator.userAgent)) {
        document.getElementsByTagName('html')[0].setAttribute('class', `${this.device} ${this.language} mac`)
      } else {
        document.getElementsByTagName('html')[0].setAttribute('class', `${this.device} ${this.language}`)
      }
      this.$store.dispatch('app/setClientWH', { clientWidth, clientHeight })
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeChange, false)
  }
}
</script>

<style lang="less">
.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  -webkit-tap-highlight-color:rgba(0,0,0,0);//ios兼容
  background: #ffffff;
  // &.pc {
  //   font-size: 16PX;
  // }
}
</style>
